var _rect, _path, _path2, _g, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealthLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(3.88px)",
      clipPath: "url(#bgblur_0_11221_19635_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 7.76652,
    width: 50,
    height: 50,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0479 35H14.0937V41H13.0479V38.3086H10.5622V41H9.51652V35H10.5622V37.2629H13.0479V35ZM15.2962 41V35H19.0591V36.0457H16.3419V37.2629H18.4976V38.3086H16.3419V39.9543H19.0591V41H15.2962ZM22.0437 35H23.2479L25.4294 41H24.3194L23.9337 39.9371H21.3622L20.9765 41H19.8665L22.0437 35ZM21.7437 38.8914H23.5479L22.6437 36.4186L21.7437 38.8914ZM26.3199 41V35H27.3656V39.9543H29.8642V41H26.3199ZM34.8762 35V36.0457H33.0419V41H31.9962V36.0457H30.1619V35H34.8762ZM39.4352 35H40.4809V41H39.4352V38.3086H36.9495V41H35.9038V35H36.9495V37.2629H39.4352V35Z",
    fill: "#333333"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11221_19635",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 10,
    width: 19,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10H34.6429V28H16V10Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11221_19635)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2064 13.2817H32.3119C32.8503 13.2817 33.3667 13.4955 33.7474 13.8763C34.1281 14.257 34.342 14.7733 34.342 15.3117V25.4621C34.342 26.0005 34.1281 26.5169 33.7474 26.8976C33.3667 27.2783 32.8503 27.4922 32.3119 27.4922H18.1014C17.563 27.4922 17.0466 27.2783 16.6659 26.8976C16.2852 26.5169 16.0713 26.0005 16.0713 25.4621V15.3117C16.0713 14.7733 16.2852 14.257 16.6659 13.8763C17.0466 13.4955 17.563 13.2817 18.1014 13.2817H20.2064V11.5712C20.2064 10.7822 20.846 10.1426 21.6349 10.1426H28.7778C29.5668 10.1426 30.2064 10.7822 30.2064 11.5712V13.2817ZM21.6349 13.2817H28.7778V11.5712H21.6349V13.2817Z",
    fill: "#8AB497"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4889 19.2442H26.3482V18.1035C26.3482 17.801 26.228 17.5109 26.0141 17.297C25.8002 17.0831 25.5101 16.9629 25.2076 16.9629C24.9051 16.9629 24.6149 17.0831 24.401 17.297C24.1871 17.5109 24.0669 17.801 24.0669 18.1035V19.2442H22.9263C22.6238 19.2442 22.3336 19.3643 22.1197 19.5783C21.9058 19.7922 21.7856 20.0823 21.7856 20.3848C21.7856 20.6873 21.9058 20.9775 22.1197 21.1914C22.3336 21.4053 22.6238 21.5255 22.9263 21.5255H24.0669V22.6661C24.0669 22.9686 24.1871 23.2587 24.401 23.4727C24.6149 23.6866 24.9051 23.8067 25.2076 23.8067C25.5101 23.8067 25.8002 23.6866 26.0141 23.4727C26.228 23.2587 26.3482 22.9686 26.3482 22.6661V21.5255H27.4889C27.7914 21.5255 28.0815 21.4053 28.2954 21.1914C28.5093 20.9775 28.6295 20.6873 28.6295 20.3848C28.6295 20.0823 28.5093 19.7922 28.2954 19.5783C28.0815 19.3643 27.7914 19.2442 27.4889 19.2442Z",
    fill: "white",
    stroke: "#8AB497",
    strokeWidth: 0.714286
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_11221_19635_clip_path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthLogo);
export default __webpack_public_path__ + "static/media/healthLogo.a3cf859fac1ff86def2c293e3ab164a3.svg";
export { ForwardRef as ReactComponent };